import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { Connections } from 'src/app/core/interface/auth.model';
import { ProfileService } from 'src/app/core/services/profile.service';
import { environment } from 'src/environments/environment';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { UploadSpaceModalComponent } from '../../wipod/upload-publication/upload-space-modal/upload-space-modal.component';
import { AuthService } from './../../../core/services/auth.service';

@Component({
  selector: 'app-connection-confirmation-modal',
  templateUrl: './connection-confirmation-modal.component.html',
  styleUrls: ['./connection-confirmation-modal.component.scss']
})
export class ConnectionConfirmationModalComponent implements OnInit {

  @Input() public userData;
  @Input() public isBlock;
  @Input() public currentuser;
  @Input() public isAllModal;
  @Input() public return;
  @Input() public title;
  @Input() public message;
  @Input() public successBtn;
  imagePath: any;
  connectionId = 0;
  constructor(
    private activeModal: NgbActiveModal,
    private _profileService: ProfileService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private _authService: AuthService
  ) { }

  ngOnInit() {
    this.connectionId = (this.isAllModal) ? this.userData.user.id : this.userData.user.connection_id;
    this.imagePath = environment.url;
  }

  closeDialog() {
    this.activeModal.close();
  }

  removeConnection() {
    let connecitonId = (this.isAllModal) ? this.userData.user.id : this.userData.user.connection_id;
    this.spinner.show();
    this._profileService.deleteConnection(connecitonId).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          // const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          // modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.CONNECTION_DELETE_SUCCESSFULLY;
          this.activeModal.close('success');
        }
        else {
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          if (response.errors == "You are not able to unfriend your parent account!") {
            modelRef.componentInstance.message = "Oops!, you cannot unfriend your parent account.";
          }
          else if (response.errors == "You can't unfriend your child account!") {
            modelRef.componentInstance.message = "Oops!, you cannot unfriend your supplementary account.";
          }
          modelRef.componentInstance.title = "Alert!";
          this.spinner.hide();
          this.activeModal.close();
        }
      }, (error: any) => {
        this.spinner.hide();
        // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      });
  }

  blockConnection() {
    let connecitonId = (this.isAllModal) ? this.userData.user.id : this.userData.user.connection_id;
    if (connecitonId === 0 && this.currentuser && this.currentuser.id && !this.currentuser.blocked) {
      const params = {
        contact_id: this.currentuser.id
      };
      this.spinner.show();
      this._profileService.blockUserAndContent(params).subscribe(
        (response: any) => {
          if (response.success) {
            const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modelRef.componentInstance.message = "User blocked successfully";
            modelRef.result.then((response) => {
              this.activeModal.close('success');
            }, (reason) => {
              this.activeModal.close('success');
            });
            this.spinner.hide();
          }
          else if (response.message == "You are not able perform this action!") {
            const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            if (this._authService.isSupplementaryAccount()) {
              modelRef.componentInstance.message = "Oops!, you cannot block your parent account.";
            }
            else {
              modelRef.componentInstance.message = "Oops!, you cannot block your supplementary account.";
            }
            modelRef.componentInstance.title = "Alert!";
            this.spinner.hide();
            this.activeModal.close();
          }
          else if (response.errors) {
            const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
            modalRef.componentInstance.contentAccessError = response.errors;
            modalRef.componentInstance.isRedirectRequired = false;
            this.spinner.hide();
            this.activeModal.close();
          }

        }, (error: any) => {
          this.spinner.hide();
          // this.toastr.error(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        });
      return;
    }
    if (connecitonId != 0) {
      const params: Connections = {
        connection: {
          status: 'blocked'
        }
      };
      this.spinner.show();
      this._profileService.blockConnection(connecitonId, params).subscribe(
        (response: any) => {
          if (response.success) {
            const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.CONNECTION_BLOCKED_SUCCESS;
            this.spinner.hide();
            modelRef.result.then((response) => {
              this.activeModal.close('success');
            }, (reason) => {
              this.activeModal.close('success');
            });
          }
          else if (response.message == "You are not able perform this action!") {
            const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            if (this._authService.isSupplementaryAccount()) {
              modelRef.componentInstance.message = "Oops!, you cannot block your parent account.";
            }
            else {
              modelRef.componentInstance.message = "Oops!, you cannot block your supplementary account.";
            }

            modelRef.componentInstance.title = "Alert!";
            this.spinner.hide();
            this.activeModal.close();
          }
          else if (response.errors) {
            const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
            modalRef.componentInstance.contentAccessError = response.errors;
            modalRef.componentInstance.isRedirectRequired = false;
            this.spinner.hide();
            this.activeModal.close();
          }
        }, (error: any) => {
          this.spinner.hide();
          // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        });
    }
  }
  returnClose() {
    this.activeModal.close('success');
  }
}
